import { Enums } from '@bode-canada/core';
import Listing from '@/models/listing';
import { LISTING_TRACK_EVENT_ORIGIN_TYPES } from '@/constants';

const ListingMixin = {
  data() {
    return {
      listingDto: null,
    };
  },
  computed: {
    listing() {
      return new Listing(this.listingDto || {});
    },
    analyticsOrigin() {
      return this.listing.origin === Enums.ListingOriginEnum.BODE
        ? LISTING_TRACK_EVENT_ORIGIN_TYPES.Bode
        : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;
    },
  },
  methods: {
    setOwnership(ownership) {
      this.listingDto.listing.ownership = ownership;
    },
  },
};

export default ListingMixin;
